import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/TopUsersBox.css';

const TopUsersBox = () => {
  const navigate = useNavigate();
  const [topUsers, setTopUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTopUsers = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/auth/top?limit=5`
        );
        // Sort by followers count
        const sorted = response.data
          .sort((a, b) => (b.followers?.length || 0) - (a.followers?.length || 0))
          .slice(0, 5);
        setTopUsers(sorted);
      } catch (err) {
        console.error('Error fetching top users:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchTopUsers();
  }, []);

  const handleUserClick = (userId) => {
    navigate(`/profile/${userId}`);
  };

  if (loading) {
    return (
      <div className="top-users-box">
        <div className="box-header">
          <h3>🌟 Топ пользователей</h3>
        </div>
        <div style={{ textAlign: 'center', color: '#666', padding: '2rem' }}>
          Загрузка...
        </div>
      </div>
    );
  }

  return (
    <div className="top-users-box">
      <div className="box-header">
        <h3>👑 Топ по подписчикам</h3>
      </div>
      <div className="users-list">
        {topUsers.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#666', padding: '1rem' }}>
            Пользователей нет
          </div>
        ) : (
          topUsers.map((user, index) => (
            <div
              key={user._id}
              className={`user-item user-item-${index}`}
              onClick={() => handleUserClick(user._id)}
            >
              <div className="rank-badge">#{index + 1}</div>
              <div className="user-avatar">
                {user.profilePicture ? (
                  <img
                    src={`http://localhost:5000${user.profilePicture}`}
                    alt={user.username}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                ) : (
                  <span>{user.firstName?.charAt(0)}{user.lastName?.charAt(0)}</span>
                )}
              </div>
              <div className="user-info">
                <div className="user-name" style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                  {user.icon && (
                    <img 
                      src={`http://localhost:5000${user.icon}`} 
                      alt="icon"
                      style={{
                        width: '18px',
                        height: '18px',
                        borderRadius: '50%',
                        objectFit: 'cover',
                        backgroundColor: 'transparent'
                      }}
                    />
                  )}
                  <span style={{color: user.nicknameColor || '#ffffff'}}>
                    {user.firstName} {user.lastName}
                  </span>
                  {user.badge && <span style={{fontSize: '0.9rem'}}>{user.badge}</span>}
                  {user.isVerified && <span className="verified-mark">✓</span>}
                </div>
                <div className="user-handle">@{user.username}</div>
                <div className="followers-count">
                  👥 {user.followers?.length || 0} подписчиков
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default TopUsersBox;
